import { COLOR } from 'app-v2/design-tokens'
import React from 'react'
import type { Icon } from 'shared/utils'

const Lock = (props: Icon) => {
    const { color = COLOR.PRIMARY, size = 24, className = 'lock' } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            fill={color}
            viewBox="0 0 24 24"
            preserveAspectRatio="none">
            <path d="M6.845 18.68h10.271v-8.286H6.846v8.285zm-.572-9.432h11.416c.316 0 .573.257.573.573v9.43a.573.573 0 0 1-.573.574H6.273a.573.573 0 0 1-.573-.573V9.82c0-.316.256-.573.573-.573z" />
            <path d="M9.175 9.783a.573.573 0 0 1-1.146 0v-1.68a3.938 3.938 0 0 1 3.933-3.933 3.938 3.938 0 0 1 3.933 3.933v1.68a.573.573 0 0 1-1.146 0v-1.68a2.792 2.792 0 0 0-2.787-2.788 2.792 2.792 0 0 0-2.787 2.788v1.68zm1.25 3.589c0-.848.727-1.575 1.575-1.575.86 0 1.575.7 1.575 1.575 0 .608-.33 1.148-.84 1.405v2.031a.43.43 0 0 1-.43.43h-.61a.43.43 0 0 1-.43-.43v-2.037a1.602 1.602 0 0 1-.84-1.4zm1.784.689c.295-.069.507-.349.507-.69a.72.72 0 0 0-.716-.715.746.746 0 0 0-.716.716c0 .322.233.62.515.69a.43.43 0 0 1 .201.115.429.429 0 0 1 .209-.116z" />
        </svg>
    )
}

export { Lock }
